import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { offerSorting } from 'src/areas/product/actions/product';
import ViewportContext from '../../../../../components/viewport/context';
import { OfferlistSorting } from '../offer-list-sorting';
import { getSortingFromUserSettings } from '../offer-list-filters/utils';
import { useEffectOnMount } from 'src/hooks/useEffectOnMount';
import FilterToggleButton from '../offer-list-filters/components/filter-toggle-button';
import { IncludeShippingFilter } from '../offer-list-filters/components/include-shipping-filter';
import { OfferlistFilters } from '../offer-list-filters';
import { ProductConditionSummary, VariantGroup } from 'src/types';
import { Header, HeaderButtons } from '../styles';

const PriceListHeader: React.VFC<IPriceListHeader> = props => {
  const { isMobile } = useContext(ViewportContext);
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const closeHandler = () => setShowFilters(false);
  const toggleHandler = () => setShowFilters(!showFilters);
  const dispatch = useDispatch();

  useEffectOnMount(() => {
    const storedSort = getSortingFromUserSettings();
    if (storedSort) {
      dispatch(offerSorting(storedSort));
    }
  });

  return (
    <Header data-test="PricePanelHeader">
      <HeaderButtons>
        <FilterToggleButton
          showFilters={showFilters}
          toggleHandler={toggleHandler}
        />
        <IncludeShippingFilter />
        {!isMobile && <OfferlistSorting />}
      </HeaderButtons>
      <OfferlistFilters
        visible={showFilters}
        closeHandler={closeHandler}
        conditions={props.conditions}
        variantGroups={props.variantGroups}
        categoryId={props.categoryId}
      />
    </Header>
  );
};

interface IPriceListHeader {
  variantGroups?: VariantGroup[] | null;
  conditions: ProductConditionSummary[];
  categoryId: string | undefined;
}

export default PriceListHeader;
